/**
 * Created by hp on 2017/6/13.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'react-weui';
import iconQR from '../../images/icon-48.jpg';
import Config from '../../config';
import { setEvent } from '../../services'

import '../../styles/lecture/LectureBottomNav.css'

class LecturePayLecture extends Component {
    constructor() {
        super();
        this.onOpenPayPanel = this.onOpenPayPanel.bind(this);
        this.onPayLecture = this.onPayLecture.bind(this);
        this.onOpenDiscountPanel = this.onOpenDiscountPanel.bind(this);
        this.onSignUp = this.onSignUp.bind(this)
    }

    onSignUp() {
        if(this.props.lectureId === 4846816 || this.props.lectureId === 5913334){
            let para = window.location.search === "" ? `?lecture_id=${this.props.lectureId}` : `${window.location.search}&lecture_id=${this.props.lectureId}`
            window.location = `/lecture/registration${para}`
            return;
        }
        let text = () => {
            return (
                <div>
                    <p style={{marginBottom: '15px', fontSize: '16px'}}>扫码报名</p>
                    <img style={{width: '50%'}} src={iconQR}/>
                </div>
            )
        }
        this.context.page.showAlert(text());
    }

    onOpenDiscountPanel() {
        this.props.dispatch({
            type: 'LECTURE_SHOW_DISCOUNT_PAY_PANEL'
        });

        if (this.props.newCoupon.hasCoupon && this.props.newCoupon.couponData) {
            this.props.dispatch({
                type: 'LECTURE_SET_DISCOUNT',
                payload: this.props.newCoupon.couponData
            })
        }
    }

    onOpenPayPanel() {
        this.props.dispatch({
            type: 'LECTURE_SHOW_PAY_PANEL'
        });
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_channelclick'
        })
    }

    onPayLecture() {
        const {lectureId, meta} = this.props;
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_singleclass'
        });
        setEvent({name: 'wk_lecture-pay-single'})
        this.props.dispatch({
            type: 'PAY_LECTURE',
            payload: {
                params: {
                    product: 'pay_lecture',
                    lecture_id: lectureId,
                    platform: meta.platform,
                    user_sign: meta.user_sign,
                },
                success: (data) => {
                    this.props.dispatch({
                        type: 'LECTURE_SET_GRANTED',
                        payload: {
                            lecture_access: {
                                granted: true
                            }
                        }
                    });
                    this.props.dispatch({
                        type: 'MTA_CLICK',
                        payload: 'lecture_singleclassfinishpay'
                    });
                    window.location = Config.MAIN_URL + `/lecture/${lectureId}/paysuccess${location.search}`;
                }
            }
        })
    }

    render() {
        const {channel, limitMoney, discountCode, newCoupon, lectureId} = this.props;
        let channelNeedMoney = channel && channel.need_money;

        // 课程报名特例
        if (lectureId === 5297593 || lectureId === 5913334) {
            return (
                <div className="lecture-bottom-enter-btn weui-flex__item flex_4 weui-flex" style={{fontSize: '16px'}}>
                    <Button className="weui-flex__item enter-btn flex_4" onClick={this.onSignUp}>点击报名</Button>
                </div>
            )
        }

        return (
            <div className="lecture-bottom-enter-btn weui-flex__item flex_4 weui-flex" style={{fontSize: '16px'}}>
                {channelNeedMoney ?
                    <Button className="weui-flex__item enter-btn flex_4"
                            onClick={((discountCode || newCoupon.canUseCouponBuy) && limitMoney !== 0) ? this.onOpenDiscountPanel : this.onOpenPayPanel}>购买课程</Button>
                    :
                    ((discountCode || newCoupon.canUseCouponBuy) && limitMoney !== 0) ?
                        <Button className="weui-flex__item enter-btn flex_4"
                                onClick={this.onOpenDiscountPanel}>购买课程</Button>
                        :
                        <Button className="weui-flex__item enter-btn flex_4"
                                onClick={this.onPayLecture}>
                            {
                                limitMoney === 0
                                    ? '限时免费'
                                    : `购买课程`
                            }
                        </Button>
                }
            </div>
        )
    }
}

LecturePayLecture.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    channel: state.lecture.channel,
    lectureMoney: state.lecture.lecture.money,
    lectureId: state.lecture.lecture.id,
    discount: state.lecture.discount,
    discountCode: state.lecture.discount.code,
    limitMoney: state.lecture.lecture.limit_money ? state.lecture.lecture.limit_money.money : null,
    newCoupon: state.newCoupon,
    meta: state.lecture.meta,
}))(LecturePayLecture);


// WEBPACK FOOTER //
// ./src/components/lecture/LecturePayLecture.js